import { string } from "prop-types"
import { Router, redirectTo } from "@reach/router"
import { FullscreenLayout } from "source/shared/Layout"
import { AlertMessage } from "source/shared/AlertMessage"
import { Loading } from "source/shared/Loading"
import Expired from "source/registrations/reservations/Expired"
import New from "source/registrations/reservations/New"
import Reservation from "source/registrations/reservations/Reservation"
import { useRegistrationsFeature } from "source/registrations/features_and_settings"
import { useSession } from "source/hooks/useSession"
import useEvent from "source/registrations/hooks/useEvent"
import { transformResponse } from "@planningcenter/api-client"
import { ReservationContextProvider } from "source/registrations/reservations/ReservationContext"

const Reservations = ({ eventId }) => {
  const isUpdatedFlow = useRegistrationsFeature(
    "unified_detailed_signups_ccw",
    eventId,
  )

  const currentPerson = transformResponse(useSession())
  const event = useEvent(eventId)

  if (event.loading) return <Loading />
  if (event.errors) return <AlertMessage>{event.errors[0].detail}</AlertMessage>

  const {
    data: { name, registrationType, guestMode },
  } = event

  const session = {
    ...currentPerson.data,
    isGuest: !currentPerson.meta.authenticated,
    isAuthenticated: currentPerson.meta.authenticated,
  }

  if (registrationType === "detailed" && !isUpdatedFlow) {
    redirectTo(`/registrations/events/${eventId}/registrations/new`)
  }

  if (guestMode === "disabled" && session.isGuest) {
    redirectTo(`/login?return=${window.location.href}`)
  }

  return (
    <FullscreenLayout>
      <Router>
        <Expired path="/expired" eventName={name} />
        <New path="/new" />
        <ReservationContextProvider
          path="/:reservationUuid"
          eventId={eventId}
          initialState={{ event }}
        >
          <Reservation path="/*" session={session} />
        </ReservationContextProvider>
      </Router>
    </FullscreenLayout>
  )
}

Reservations.propTypes = {
  eventId: string,
}

export default Reservations
